import React from 'react';

import Grid from 'react-bootstrap/lib/Grid'
import Col from 'react-bootstrap/lib/Col'
import Row from 'react-bootstrap/lib/Row'
import { pdpApi2, collectionsHomepageAPI, bestSellerAPI } from '../../../../public/constants/constants';
import apiManager from '../../../utils/apiManager';
import {createSEOPdpURL, formatPrice} from '../../../utils/utilityManager';

class DescriptionBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      splitData: null,
      fullData: this.props.descriptionDataPro.description,
      title: this.props.descriptionDataPro.title,
      finalData: this.props.descriptionDataPro.description,
      isReadMore: false,
      readMoreTitle: 'READ MORE',
      plpDescriptionProductsData:[],
      productListTitle:'',
      productListColumnName1:'',
      productListColumnName2:'',
      isMobile: window.innerWidth <= 768,
    };
  }
  
  // scrollToRef = (abc) => window.scrollTo(0, abc.offsetTop)   
  // useMountEffect = (fun) => useEffect(fun, [])

  initBanner(getData) {
    let charLimit;
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ) {
      charLimit = getData.descriptionDataPro.mobileCharLimit
    } else {
      charLimit = getData.descriptionDataPro.webCharLimit;
    }
    // let trimStr;
    // if(getData.descriptionDataPro.description != null)
    // {
    //   trimStr = `${getData.descriptionDataPro.description.substring(
		//   0,
		//   charLimit,
    //   )}...`;
    // }
    this.setState({
      // splitData: trimStr,
      // finalData: trimStr,
      title: getData.descriptionDataPro.title,
      
      productListTitle:getData.descriptionDataPro.productListTitle,
      productListColumnName1:getData.descriptionDataPro.productListColumnName1,
      productListColumnName2:getData.descriptionDataPro.productListColumnName2,

    }
    ,()=>{this.resolveTabData(getData)}
    );
  }
  
  resolveTabData=async(getData)=>{
    // console.log(this.props.descriptionDataPro.productListWithPrice.plpDescriptionProductsData)
    // let data = []
    // if(this.props.descriptionDataPro.productListWithPrice.length>0){
    //   this.setState({
    //     plpDescriptionProductsData:getData.descriptionDataPro.productListWithPrice,
    //   })
    // }
    // else{
      if(typeof this.props.descriptionDataPro.productListWithPrice == 'string'){
        apiManager
      .get(collectionsHomepageAPI + this.props.descriptionDataPro.productListWithPrice)
      .then(response => {
        const {data} = response || {}
        const productList = data && data.data.productList;
        this.setState({
          plpDescriptionProductsData: productList,
          isLoading: false,
        });
      })
      .catch(error => {
        this.setState({
        });
      });
      }else{
        this.setState({
          plpDescriptionProductsData:getData.descriptionDataPro.productListWithPrice
        })
      }
      
    // }
   
  }


  componentDidMount() {
    this.initBanner(this.props);
    // console.log(this.props)
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.descriptionDataPro !== this.props.descriptionDataPro) {
      this.initBanner(nextProps);
    }
    // if (this.state.isReadMore) {
    //   this.setState({
    //     isReadMore: false,
    //     finalData: this.state.splitData,
    //     readMoreTitle: 'READ MORE',
    //   });
    //   //   this.scrollToRef(this.ref.description)
    // } 
  }

  
  // readMoreClicked() {
  //   if (!this.state.isReadMore) {
  //     this.setState({
  //       isReadMore: true,
  //       finalData: this.state.splitData,
  //       readMoreTitle: 'READ MORE',
  //     });
  //     // this.scrollToRef(this.abc.description)
  //   } else {
  //     // debugger;
  //     // const a = document.getElementsByClassName('descriptionBanner');
      
  //     this.setState({
  //       isReadMore: false,
  //       finalData: this.props.descriptionDataPro.description,
  //       readMoreTitle: 'READ LESS',
  //     });
  //   }
  // }

  

  
  render() {
    const { finalData } = this.state
    return (
      !!finalData && (
        <div ref="description" className="descriptionBanner">
          {this.props.isHomepage ? (<Grid>
            <Row>
              <Col md={12}>
                {this.props.isH1Tag ? <h1 className="heading">{this.state.title}</h1> : this.props.isPlp ?  <div className="heading">{this.state.title}</div>  : <h3 className="heading">{this.state.title}</h3>}
                
                <ul className="description_area">
                  <div
                    dangerouslySetInnerHTML={{ __html: this.state.fullData }}
                  />
                </ul>
               
              </Col>
            </Row>
          </Grid>) : (<Grid>
            {this.state.plpDescriptionProductsData==undefined ?
              <Row>
                <Col md={12}>
                  {this.props.isH1Tag ? <h1 className="heading">{this.state.title}</h1> : this.props.isPlp ?  <div className="heading">{this.state.title}</div>  : <h3 className="heading">{this.state.title}</h3>}
                
                  <ul className="description_area">
                    <div
                      dangerouslySetInnerHTML={{ __html: this.state.finalData }}
                    />
                  </ul>
                  {/* <button
                    onClick={this.readMoreClicked.bind(this)}
                    className="readMore"
                  >
                    {this.state.readMoreTitle}
                  </button> */}
                </Col>
              </Row>

              :
            
              this.state.isMobile ?
                <>
                  <Row>
                    <Col md={12}>
                      <div className='plp-productlist-table-title'>{this.state.productListTitle}</div>
                      <table className="plp-productlist-table table table-non-striped" width="100%">{
                        <>
                          <tr className='table-heading'><td>{this.state.productListColumnName1}</td><td>{this.state.productListColumnName2}</td> </tr>
                          {!!this.state.plpDescriptionProductsData && this.state.plpDescriptionProductsData.map((tabContent, id) => (					
                            <tr key={id}>						
                              <td><a href={tabContent.productUrl != undefined ? tabContent.productUrl : createSEOPdpURL(tabContent.productName, tabContent.shortDescription, tabContent.partNumber)} className='FranchiseLinkBanner-Desktop'>{tabContent.productName}</a></td>
                              <td>&#8377;{tabContent.productPrice != undefined? formatPrice(tabContent.productPrice) : formatPrice(tabContent.offerPrice) }</td>
                            </tr>	
                          ))}
                        </>
                      }</table>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      {this.props.isH1Tag ? <h1 className="heading">{this.state.title}</h1> : this.props.isPlp ?  <div className="heading">{this.state.title}</div>  : <h3 className="heading">{this.state.title}</h3>}
                
                      <ul className="description_area">
                        <div
                          dangerouslySetInnerHTML={{ __html: this.state.finalData }}
                        />
                      </ul>
                      {/* <button
                        onClick={this.readMoreClicked.bind(this)}
                        className="readMore"
                      >
                        {this.state.readMoreTitle}
                      </button> */}
                    </Col>
                  </Row>
                </>
                :
            
            
                <Row>
                  <Col md={8}>
                    {this.props.isH1Tag ? <h1 className="heading">{this.state.title}</h1> : this.props.isPlp ?  <div className="heading">{this.state.title}</div>  : <h3 className="heading">{this.state.title}</h3>}
                
                    <ul className="description_area">
                      <div
                        dangerouslySetInnerHTML={{ __html: this.state.finalData }}
                      />
                    </ul>
                    {/* <button
                      onClick={this.readMoreClicked.bind(this)}
                      className="readMore"
                    >
                      {this.state.readMoreTitle}
                    </button> */}
                  </Col>
                  {this.state.plpDescriptionProductsData.length>0?
                   <Col md={4}>
                   <div className='plp-productlist-table-title'>{this.state.productListTitle}</div>
                   <table className="plp-productlist-table table table-non-striped" width="100%">{
                     <>
                       <tr className='table-heading'><td>{this.state.productListColumnName1}</td><td>{this.state.productListColumnName2}</td> </tr>
                       {this.state.plpDescriptionProductsData.map((tabContent, id) => (					
                         <tr key={id}>						
                           <td><a href={tabContent.productUrl != undefined ? tabContent.productUrl : createSEOPdpURL(tabContent.productName, tabContent.shortDescription, tabContent.partNumber)} className='FranchiseLinkBanner-Desktop'>{tabContent.productName}</a></td>
                           <td>&#8377;{tabContent.productPrice != undefined? formatPrice(tabContent.productPrice) : formatPrice(tabContent.offerPrice) }</td>
                         </tr>	
                       ))}
                     </>
                   }</table>
                 </Col>
                  :<></>}
                 
                </Row>
            
            
            
            
            
            
            
            }
          </Grid>)
          }
        </div>
      )
    );
  }
}

export default DescriptionBanner;
